import actionTypes from "./actionTypes";
import * as userUtils from "../utils/userUtils";

const signInSuccess = (res) => ({
  type: actionTypes.SIGN_IN_SUCCESS,
  res
});

const signInRequest = () => ({
  type: actionTypes.SIGN_IN_REQUEST,
});

const signInFailure = (error) => ({
  type: actionTypes.SIGN_IN_FAILURE,
  error
});

export const signOut = () => ({
  type: actionTypes.SIGN_OUT
});

export const signIn = (username, password) => {
  return async (dispatch) => {
    try {
      dispatch(signInRequest());
      let user = await userUtils.signIn(username, password);
      dispatch(signInSuccess(user));
    } catch (error) {
      console.error(error);
      dispatch(signInFailure(error));
    }
  }
}

export const afterSignIn = (res) => {
  return async (dispatch) => {
    try {
      dispatch(signInSuccess(res));
    } catch (error) {
      console.error(error);
      dispatch(signInFailure(error));
    }
  }
}

const updatePasswordSuccess = (res) => ({
  type: actionTypes.UPDATE_PASSWORD_SUCCESS,
  res
});

const updatePasswordRequest = () => ({
  type: actionTypes.UPDATE_PASSWORD_REQUEST,
});

const updatePasswordFailure = (error) => ({
  type: actionTypes.UPDATE_PASSWORD_FAILURE,
  error
});

export const updatePassword = (password) => {
  return async (dispatch) => {
    try {
      dispatch(updatePasswordRequest());
      let user = await userUtils.updatePassword(password);
      dispatch(updatePasswordSuccess(user));
    } catch(error) {
      console.error(error);
      dispatch(updatePasswordFailure(error));
    }
  }
}

export const refreshToken = () => {
  return async (dispatch) => {
    try {
      dispatch(signInRequest());
      let user = await userUtils.refreshToken();
      dispatch(signInSuccess(user));
    } catch(error) {
      console.error(error);
      dispatch(signInFailure(error));
    }
  }
}

export const verifyCode = (code) => {
  return async (dispatch) => {
    try {
      dispatch(signInRequest());
      let user = await userUtils.verifyCode(code);
      dispatch(signInSuccess(user));
    } catch(error) {
      console.error(error);
      dispatch(signInFailure(error));
    }
  }
}

const createCodeSuccess = () => ({
  type: actionTypes.CREATE_CODE_SUCCESS
});

const createCodeRequest = () => ({
  type: actionTypes.CREATE_CODE_REQUEST,
});

const forgetPasswordFailure = (error) => ({
  type: actionTypes.CREATE_CODE_FAILURE,
  error
});

export const createCode = (username) => {
  return async (dispatch) => {
    try {
      dispatch(createCodeRequest());
      await userUtils.createCode(username);
      dispatch(createCodeSuccess());
    } catch(error) {
      console.error(error);
      dispatch(forgetPasswordFailure(error));
    }
  }
}

// UPDATE
const updateUserRequest = () => ({
  type: actionTypes.UPDATE_USER_REQUEST,
});
const updateUserSuccess = (res) => ({
  type: actionTypes.UPDATE_USER_SUCCESS,
  res,
});
const updateUserFailure = (error) => ({
  type: actionTypes.UPDATE_USER_FAILURE,
  error,
});
export const updateUser = (data) => {
  return async (dispatch) => {
    try {
      dispatch(updateUserRequest());
      let res = await userUtils.updateUser(data);
      dispatch(updateUserSuccess(res));
    } catch (error) {
      dispatch(updateUserFailure(error));
    }
  };
};
